import { FC } from "react";
import styled from "styled-components";

interface Props {
  checked: boolean;
}
const StyleCheck = styled.div`
  position: absolute;
  top: calc(50% - 1px);
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  content: "";
  width: 10px;
  height: 6px;
  border-bottom: 2px solid #000;
  border-left: 2px solid #000;
`;

const Checkbox: FC<Props> = ({ checked }): JSX.Element => {
  return (
    <div className="relative border border-gray-100 bg-white w-16 h-16 rounded-xs">
      {checked && <StyleCheck />}
    </div>
  );
};
export default Checkbox;
